import React from 'react';
// import JsonView from "./JsonView";
import Api from '../Api';
import Util from '../Util';
import ReactSpinner from 'react-spinjs';

class KioskUpdateHistory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      historyList: [],
      count: 10,
      loadingHistoryList: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchHistoryList(this.props.hostInfo);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchHistoryList(nextProps.hostInfo);
  }

  fetchHistoryList(hostInfo, count = 10) {
    if (!hostInfo.fingerprint || !hostInfo.kioskId) {
      return;
    }
    this.setState({ loadingHistoryList: true });
    Api.getKioskUpdateHistoryList(hostInfo, 0, count).then((historyList) => {
      this.setState({ historyList, count, loadingHistoryList: false });
    });
  }

  handleLoadMore = () => {
    let count = this.state.count + 10;
    this.fetchHistoryList(this.props.hostInfo, count);
  };

  render() {
    let { historyList, loadingHistoryList } = this.state;

    if (loadingHistoryList) {
      return <ReactSpinner />;
    }

    return (
      <div style={{ background: 'rgb(255, 255, 250)', padding: '30px', margin: '0' }}>
        <h1>Kiosk Update History</h1>

        {historyList.length === 0 && <div>No history found.</div>}

        {historyList.map((hist) => {
          return <HistoryBlock key={hist.dateCreated} hist={hist} />;
        })}

        {historyList.length > 0 && (
          <div style={{ textAlign: 'right' }}>
            Showing {historyList.length} entries |{' '}
            <a href='javascript:void(0)' onClick={this.handleLoadMore}>
              Load 10 more entries
            </a>
          </div>
        )}

        {/*
        {historyList.length > 0 &&
          <JsonView title={"historyList JSON Data"} data={historyList}
                    hideRoot={true}
                    shouldExpandNode={(levels, obj, level) => level <= 0}
                    collectionLimit={150}
                    raw={false}
          />
        }
      */}
      </div>
    );
  }
}

function HistoryBlock(props) {
  let { hist } = props;
  let title = hist.kioskVersionSetName + ' - ' + hist.createdBy;
  if (hist.kioskUpdaterCommand) {
    title = hist.kioskUpdaterCommand;
  }
  return (
    <div className='pure-g' style={{ border: '1px solid #ccc', padding: 10, margin: 30 }}>
      <div className='pure-u-3-4' style={{ textAlign: 'left' }}>
        <h2 style={{ textAlign: 'left', paddingBottom: 10, margin: 0 }}>{title}</h2>
      </div>
      <div className='pure-u-1-4' style={{ textAlign: 'right', fontWeight: 500 }}>
        {Util.xUnitsOfTimeAgo(hist.dateCreated)} <br /> {Util.localDateTimeString(hist.dateCreated)}
      </div>
      <VersionRow {...props} />
      <pre
        className='pure-u-1-1'
        style={{ border: hist.hasError ? '1px solid darkred' : '1px solid #efefef', padding: 10 }}
      >
        {hist.result}
      </pre>
      <div className='pure-u-1-1' style={{ color: hist.hasError ? 'darkred' : '' }}>
        {hist.hasError ? 'Error in Update' : ''}
      </div>
    </div>
  );
}

function VersionRow(props) {
  let { hist } = props;
  return (
    <div className='pure-u-1' style={{ fontSize: 12 }}>
      <div className='pure-u-3-24'>
        <span className='kvs-em'>printapi</span>
        <br /> {hist.printapi}
      </div>
      <div className='pure-u-3-24'>
        <span className='kvs-em'>payapi</span>
        <br /> {hist.payapi}
      </div>
      <div className='pure-u-3-24'>
        <span className='kvs-em'>capui</span>
        <br /> {hist.capui}
      </div>
      <div className='pure-u-3-24'>
        <span className='kvs-em'>kioskprobe</span>
        <br /> {hist.kioskprobe}
      </div>
      <div className='pure-u-3-24'>
        <span className='kvs-em'>kskapi</span>
        <br /> {hist.kskapi}
      </div>
      <div className='pure-u-3-24'>
        <span className='kvs-em'>cafeapi</span>
        <br /> {hist.cafeapi}
      </div>
      <div className='pure-u-2-24'>
        <span className='kvs-em'>heatwave</span>
        <br /> {hist.heatwave}
      </div>
      <div className='pure-u-2-24'>
        <span className='kvs-em'>linuxdash</span>
        <br /> {hist.linuxdash}
      </div>
      <div className='pure-u-2-24'>
        <span className='kvs-em'>ciscoamp</span>
        <br /> {hist.ciscoamp}
      </div>
    </div>
  );
}

export default KioskUpdateHistory;



// WEBPACK FOOTER //
// ./src/components/KioskUpdateHistory.js